import {
  isRecoverableAssetElement,
  isRecoverableAssetLoadError,
  requestAssetRecovery,
} from 'src/utils/asset-recovery';

/**
 * Global listeners used to react to errors happening outside of React.
 *
 * `Sentry.init()` installs its own `window.onerror` / `window.onunhandledrejection`
 * handlers by assigning them and chaining the previous one. Since this runs
 * after `Sentry.init()`, we must chain them too: overwriting them outright
 * would silence Sentry's own reporting (and mislabel every crash as `handled`).
 * Reporting is therefore left entirely to Sentry; we only add the asset
 * recovery side effects.
 */
export function registerGlobalErrorListeners() {
  window.addEventListener(
    'error',
    (event) => {
      if (isRecoverableAssetElement(event.target)) {
        requestAssetRecovery('asset-element-error', event);
      }
    },
    true,
  );

  const previousOnError = window.onerror;
  window.onerror = (msg, url, line, col, error) => {
    const result = previousOnError?.call(window, msg, url, line, col, error);

    if (isRecoverableAssetLoadError(error || msg)) {
      requestAssetRecovery('window-error', error || msg);
    }

    return result;
  };

  const previousOnUnhandledRejection = window.onunhandledrejection;
  window.onunhandledrejection = (event) => {
    const result = previousOnUnhandledRejection?.call(window, event);

    if (isRecoverableAssetLoadError(event.reason)) {
      requestAssetRecovery('unhandled-rejection', event.reason);
    }

    return result;
  };
}
